__turbopack_context__.v({
  "root": "MobileRecoveryComponent-module__1IVKNW__root",
});
